/* eslint-disable quote-props */
import ITCAvantGardeGothicPro from '../images/style-pack-fonts/itc-avant-garde-gothic-pro.svg';
import LoraFoundersGrotesk from '../images/style-pack-fonts/lora-founders-grotesk.svg';
import NaicheExtraBold from '../images/style-pack-fonts/naiche-extra-bold.svg';
import PoppinsMedium from '../images/style-pack-fonts/poppins-medium.svg';
import BeniBlack from '../images/style-pack-fonts/beni-black.svg';
import { FieldValue } from '../components/types/stylepacks';

interface Template {
	type: string,
	url: string,
	thumbnail: string,
	default: Record<string, FieldValue>;
}

export const STATIC_ASSET_URL = process.env.REACT_APP_ASSET_URL
	? process.env.REACT_APP_ASSET_URL
	: 'https://greenroom-static-assets.greenroom-dev.brandlive.cloud';

export const nonEditTypes = [
	'brandlive-back-to-school-countdown',
];

export const genericOverlayTemplate: Template = {
	type: 'generic',
	url: '',
	thumbnail: '',
	default: {
		userName: 'Isabella Cooper',
		userSubhead: 'VP of Marketing',
		shape: 'Rounded',
		color1: '#FFFFFF',
		color2: '#040303',
		color3: '#F79BC4',
		color4: '#FBE045',
	},
};

export const contentTemplateStyles: Template[] = [
	{
		type: 'brandlive-style-pack-20',
		url: `${STATIC_ASSET_URL}/title_templates/misc/misc-lower.webm`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/misc/thumbs/misc-lower.png`,
		default: {
			userName: 'Daniel',
			userSurname: 'Murphy',
			userSubhead: 'Brandlive Studios',
			color2: '#000000',
			color1: '#FFFFFF',
			color3: '#BAF3FD',
			color4: '#FFFFFF',
			color5: '#FBF5A8',
			color6: '#ED73E0',
		},
	},
	{
		type: 'brandlive-walkups',
		url: `${STATIC_ASSET_URL}/title_templates/misc/misc-walkup.mp4`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/misc/thumbs/misc-walkup-picture.png`,
		default: {
			eventName: 'Brandlive Studios',
			'speaker1-headshot': `${STATIC_ASSET_URL}/title_templates/misc/thumbs/misc-walkup-picture.png`,
			'speaker1-name': 'Daniel Murphy',
			'speaker1-position': 'Future Horizons',
			'speaker1-company': '',
			'speaker2-headshot': `${STATIC_ASSET_URL}/title_templates/misc/thumbs/misc-walkup-picture-2.png`,
			'speaker2-name': 'Nell Lynch',
			'speaker2-position': 'Future Horizons',
			'speaker2-company': '',
			// eslint-disable-next-line no-template-curly-in-string
			'oneToManyField': 'speaker${i}-headshot',
			'oneToManyLabel': 'Presenter',
			'button-text': 'Add presenter',
			'button-icon': 'SHARE',
			bgColor: '#67878F',
			accentColor: '#9CC0BA',
			textColor: '#E6E1D5',
		},
	},
];

export interface StylePackColorPalette {
	name: string,
	colors: string[],
};

export interface StylePackOption {
	name: string, // name of the option
	type: string, // colorway or font
	style_pack_types: string[], // style packs that this option is available for
	data: {
		colors?: string[], // array of hex colors for colorway
		preview?: string, // svg preview for font
	},
}

export const stylePackOptions: StylePackOption[] = [
	{
		name: 'Candy Playground',
		type: 'colorway',
		style_pack_types: [
			'brandlive-back-to-school',
		],
		data: {
			colors: [
				'#FA5200',
				'#FCE33D',
				'#FFFFFF',
				'#FFD1D0',
				'#F9A4CB',
				'#040303',
			],
		},
	},
	{
		name: 'Azure Harmony',
		type: 'colorway',
		style_pack_types: [
			'brandlive-selfridges',
		],
		data: {
			colors: [
				'#4CB05D',
				'#D1DCDF',
				'#14B7FD',
				'#000000',
			],
		},
	},
	{
		name: 'Deep Lavender Lake',
		type: 'colorway',
		style_pack_types: [
			'brandlive-topo',
		],
		data: {
			colors: [
				'#413786',
				'#322F3D',
				'#1C3C3A',
			],
		},
	},
	{
		name: 'Oceanic Ember',
		type: 'colorway',
		style_pack_types: [
			'brandlive-mondrian',
		],
		data: {
			colors: [
				'#0AC28B',
				'#D5614A',
				'#2EBBD5',
				'#239CD4',
				'#0C2E32',
				'#040303',
			],
		},
	},
	{
		name: 'Galactic Yearbook',
		type: 'colorway',
		style_pack_types: [
			'brandlive-academy',
		],
		data: {
			colors: [
				'#ED0201',
				'#FFBC1E',
				'#FFF85C',
				'#FF6AE6',
				'#5AE3FF',
				'#09083F',
				'#09083F',
			],
		},
	},
	{
		name: 'Misty Horizon',
		type: 'colorway',
		style_pack_types: [
			'brandlive-walkups',
		],
		data: {
			colors: [
				'#67878F',
				'#E4E1D5',
				'#9CC0BA',
				'#67878F',
			],
		},
	},
	{
		name: 'Ethereal Elegance',
		type: 'colorway',
		style_pack_types: [
			'brandlive-style-pack-20',
		],
		data: {
			colors: [
				'#B9F6FB',
				'#F9FBB4',
				'#FFFFFF',
				'#DE5AD1',
				'#000000',
			],
		},
	},
	{
		name: 'Naiche Extra Bold',
		type: 'font',
		style_pack_types: [
			'brandlive-back-to-school',
		],
		data: {
			preview: NaicheExtraBold,
		},
	},
	{
		name: 'ITC Avant Garde Gothic Pro',
		type: 'font',
		style_pack_types: [
			'brandlive-selfridges',
		],
		data: {
			preview: ITCAvantGardeGothicPro,
		},
	},
	{
		name: 'Lora Founders Grotesk',
		type: 'font',
		style_pack_types: [
			'brandlive-topo',
		],
		data: {
			preview: LoraFoundersGrotesk,
		},
	},
	{
		name: 'Tusker Grotesk',
		type: 'font',
		style_pack_types: [
			'brandlive-mondrian',
		],
		data: {
			preview: BeniBlack,
		},
	},
	{
		name: 'Poppins Medium',
		type: 'font',
		style_pack_types: [
			'brandlive-academy',
			'brandlive-walkups',
			'brandlive-style-pack-20',
		],
		data: {
			preview: PoppinsMedium,
		},
	},
];

export const stylePackBannerImages: Record<string, string> = {
	'brandlive-back-to-school': `${STATIC_ASSET_URL}/title_templates/back-to-school/back-to-school-banner-image.png`,
	'brandlive-topo': `${STATIC_ASSET_URL}/title_templates/topo/topo-banner-image.png`,
	'brandlive-rothko': `${STATIC_ASSET_URL}/title_templates/rothko/rothko-banner-image.png`,
	'brandlive-academy': `${STATIC_ASSET_URL}/title_templates/academy/academy-banner-image.png`,
	'brandlive-mondrian': `${STATIC_ASSET_URL}/title_templates/mondrian/mondrian-banner-image.png`,
	'brandlive-tic-tac-toe': `${STATIC_ASSET_URL}/title_templates/tic-tac-toe/tic-tac-toe-banner-image.png`,
};
